export enum RequestActionLogSource {
	Sba = "SBA",
	Glad = "GLAD",
}
